export const normalizeNumber = value => {
	return value.replace(/[^\d-.,]/g, '');
};

export const normalizeNoDecimals = value => {
	return value.replace(/[^\d]/g, '');
};
